import React, { useEffect } from "react";
import { Navigate } from "react-router";

import { SEARCH_KEY } from "fond/constants";
import { Navigation } from "fond/projects/Navigation";
import RecentContent from "fond/projects/RecentContent";
import { updateFilter } from "fond/projects/redux";
import { useAppDispatch, useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

/**
 * A top level component used for displaying recent projects.
 */
const Recent: React.FC = () => {
  const dispatch = useAppDispatch();

  // Clear filter
  useEffect(() => {
    dispatch(updateFilter(null));
  }, [dispatch]);

  // Backwards-compat redirect for old /recent?search=term URLs
  const searchQuery = useQueryParams(SEARCH_KEY);
  if (searchQuery) {
    return <Navigate to={`/search?${SEARCH_KEY}=${encodeURIComponent(searchQuery)}&scope=recent`} replace />;
  }

  return <PageContent title="Recent" mainContent={<RecentContent />} navigation={<Navigation />} testId="filter-recent" />;
};

export default Recent;
